export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9758.33b12788.jpg";